import React from 'react'

const ArrowDownIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="chevron-down (98) 1">
                <path
                    id="Vector"
                    d="M6 9L12 15L18 9"
                    stroke="#272B2A"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </svg>)
}

export default ArrowDownIcon